module.exports = {
  fetch: `query getSounds {
    sounds {
      id
      category
      resourceName
      preview {
        url
      }
    }
  }`,
  remove: `
    mutation removeSounds($ids: [ID]) {
      bulkRemoveSounds(ids: $ids)
    }
  `,
  add: `mutation addSound($value: SoundInput) {
    upsertSound(sound: $value) {
      id
    }
  }`,
};
